export default "__VITE_ASSET__BFPqymBE__"